import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 0H0V24H24V0Z" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7803 5.00098C12.7808 4.58677 12.4455 4.25054 12.0313 4.25C11.617 4.24946 11.2808 4.58481 11.2803 4.99902L11.2721 11.2498H5C4.58579 11.2498 4.25 11.5856 4.25 11.9998C4.25 12.414 4.58579 12.7498 5 12.7498H11.2701L11.262 18.999C11.2614 19.4132 11.5968 19.7494 12.011 19.75C12.4252 19.7505 12.7614 19.4152 12.762 19.001L12.7701 12.7498H19C19.4142 12.7498 19.75 12.414 19.75 11.9998C19.75 11.5856 19.4142 11.2498 19 11.2498H12.7721L12.7803 5.00098Z"
      fill="currentColor"
    />
  </svg>
);
